import { InjectionToken } from '@angular/core';

export const IntegrationKindToken = new InjectionToken('INTEGRATION_KIND');
